/* eslint-disable import/no-unresolved */
import { Gallery, Item } from 'react-photoswipe-gallery';
import PropTypes from 'prop-types';
/* eslint-enable import/no-unresolved */
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'photoswipe/dist/photoswipe.css';

export const captionContent = (caption) =>
  caption && `<span class='pswp__custom-caption rounded'>${caption}</span>`;

const CarouselGallery = ({ images }) => {
  const hasMultipleImages = images.length !== 1;
  return (
    <section className="carousel-gallery">
      <Gallery withCaption>
        <Swiper
          modules={[Pagination, Navigation]}
          slidesPerView={1}
          pagination={
            hasMultipleImages
              ? {
                  type: 'custom',
                  renderCustom(swiper, current, total) {
                    return `<div class="d-flex justify-content-end me-3 "><div class="p-2 pagination-custom-background">${current} / ${total}</div></div>`;
                  },
                }
              : false
          }
          navigation={hasMultipleImages}
        >
          {images.map((image, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <SwiperSlide key={index}>
              <Item
                original={image.src}
                thumbnail={image.thumbnail}
                width={image.originalWidth}
                height={image.originalHeight}
                caption={captionContent(image.caption)}
              >
                {({ ref, open }) => (
                  <div className="ratio ratio-3x2">
                    <img
                      className="object-fit-cover"
                      ref={ref}
                      onClick={open}
                      src={image.thumbnail}
                      alt={image.alt}
                      loading="lazy"
                    />
                  </div>
                )}
              </Item>
            </SwiperSlide>
          ))}
        </Swiper>
      </Gallery>
    </section>
  );
};

const stringOrNumber = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

CarouselGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      thumbnail: PropTypes.string,
      src: PropTypes.string,
      alt: PropTypes.string,
      caption: PropTypes.string,
      originalWidth: stringOrNumber,
      originalHeight: stringOrNumber,
      thumbnailWidth: stringOrNumber,
      thumbnailHeight: stringOrNumber,
    })
  ),
};

CarouselGallery.defaultProps = {
  images: [],
};

export default CarouselGallery;
